import React from 'react'

const BoatingWebCMS = () => {
  return (
    <div>
      Web CMS
    </div>
  )
}

export default BoatingWebCMS
